<template>
    <div class="container">
        <h2>Güncelleme İşlemleri</h2>
        <div class="separator"></div>

      <li v-for="panelOperation in panelOperations" :key="panelOperation.name"
          class="swatch__wrapper" style="text-align:center">
        <b-card>
          <div @click="redirect(panelOperation.name)">
            <img :src="panelOperation.image" alt="Image" style="display:block; margin:auto;">
            <b-link style="display:block; margin-top:10px;">{{ panelOperation.title }}</b-link>
          </div>
        </b-card>
      </li>

      <h2>Raporlar</h2>
      <div class="separator"></div>

      <li v-for="reportOperation in reportOperations" :key="reportOperation.name"
          class="swatch__wrapper" style="text-align:center">
        <b-card>
          <div @click="redirect(reportOperation.name)">
            <img :src="reportOperation.image" alt="Image" style="display:block; margin:auto;">
            <b-link style="display:block; margin-top:10px;">{{ reportOperation.title }}</b-link>
          </div>
        </b-card>
      </li>

      <h2>Uyarı Yönetimi</h2>
      <div class="separator"></div>

      <li v-for="warningOperation in warningOperations" :key="warningOperation.name"
          class="swatch__wrapper" style="text-align:center">
        <b-card>
          <div @click="redirect(warningOperation.name)">
            <img :src="warningOperation.image" alt="Image" style="display:block; margin:auto;">
            <b-link style="display:block; margin-top:10px;">{{ warningOperation.title }}</b-link>
          </div>
        </b-card>
      </li>
    </div>
</template>

<script>

export default {
  data() {
    return {
      panelOperations: [],
      reportOperations: [],
      warningOperations: [],
    }
  },

  methods: {
    redirect(name) {
      this.$router.push({name: name});
    },


    async prepare() {
      const router = this.$router;
      let panelOperations = [];
      let reportOperations = [];
      let warningOperations = [];
      router.options.routes.forEach(function (item) {
        switch (item.meta.operations) {
          case "panelOperations":
            panelOperations.push({
              title: item.meta.title,
              name: item.name,
              image: item.meta.image
            });
            break;
          case "reportOperations":
            reportOperations.push({
              title: item.meta.title,
              name: item.name,
              image: item.meta.image
            });
            break;
          case "warningOperations":
            warningOperations.push({
              title: item.meta.title,
              name: item.name,
              image: item.meta.image
            });
            break;
        }
      });
      this.panelOperations = panelOperations;
      this.reportOperations = reportOperations;
      this.warningOperations = warningOperations;
    }
  },
  beforeMount() {
    this.prepare();
  }
}
</script>
<style>
    img {
        max-width: 100%;
    }

    .swatch__wrapper {
        padding: 10px 10px 10px 10px;
        display: inline-block;
        width: 25%;
        list-style: none;
        margin-top: 1.4em;
        margin-bottom: 1.4em;
        cursor: pointer;
    }

    .separator {
        border-bottom: solid 1px #ccc;
        margin-bottom: 15px;
    }
</style>
